import { type DependencyList, useState } from 'react';

import { useAsyncEffect } from '~/hooks/useAsyncEffect';

export const useAsyncMemo = <T>(factory: () => T | undefined | Promise<T | undefined>, deps: DependencyList) => {
  const [data, setData] = useState<T>();

  useAsyncEffect(async () => {
    setData(await factory());
  }, deps);

  return data;
};
